var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("FormEditor", {
        attrs: { viewModel: _vm.formEditor },
        on: { "save-form": _vm.handleRenameFormCommand },
      }),
      _vm._v(" "),
      _c("AlternativeEditorDialog", {
        attrs: { viewModel: _vm.alternativeEditorDialog },
      }),
      _vm._v(" "),
      _c("AttributeEditorDialog", {
        attrs: { viewModel: _vm.attributeEditorDialog },
        on: { "attribute-created": _vm.handleLoadAttribute },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c("div", [
            _vm.formSectionEditor.opened
              ? _c(
                  "div",
                  {
                    staticClass: "modal-mask",
                    attrs: { id: "form-section-editor" },
                  },
                  [
                    _c("div", { staticClass: "modal-wrapper" }, [
                      _c("div", { staticClass: "modal-dialog" }, [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(_vm._s(_vm.formSectionEditor.title)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.formSectionEditor.close()
                                  },
                                },
                              },
                              [_vm._v("×")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "form",
                              {
                                attrs: {
                                  id: "form-designer-form-section-editor-form",
                                },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.handleFormSectionEditorSubmit.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Name:")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.formSectionEditor.name,
                                        expression: "formSectionEditor.name",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      required: "",
                                      minlength: "2",
                                    },
                                    domProps: {
                                      value: _vm.formSectionEditor.name,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.formSectionEditor,
                                          "name",
                                          $event.target.value.trim()
                                        )
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      _vm._s(_vm.formSectionEditor.nameError)
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.formSectionEditor.close()
                                  },
                                },
                              },
                              [_vm._v("Cancel")]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "submit",
                                  form: "form-designer-form-section-editor-form",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formSectionEditor.confimButtonLabel
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-fluid",
                staticStyle: { "margin-top": "80px", "padding-top": "40px" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("h6", [
                      _c(
                        "a",
                        {
                          staticClass: "text-dark",
                          on: { click: _vm.handleBack },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-double-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" Back\n                        "),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass: "pointer",
                        staticStyle: {
                          "font-size": "2em",
                          "font-weight": "300",
                          color: "#33475b",
                          margin: "0",
                        },
                        on: { click: _vm.showFormEditor },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.formName) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6 text-right" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { type: "button" },
                        on: { click: _vm.showFormPreview },
                      },
                      [_vm._v("Preview")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { type: "button" },
                        on: { click: _vm.handleUpdateFormDefinitionCommand },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.saving ? "Saving..." : "Save form") +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              staticStyle: { "border-color": "#bbb", margin: "20px 0" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid p-0" }, [
              _c("div", { staticClass: "row no-gutters" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-lg-4 col-md-5 col-sm-6",
                    staticStyle: {
                      "max-height": "calc(100vh - 250px)",
                      height: "calc(100vh - 250px)",
                      "overflow-y": "auto",
                    },
                  },
                  [
                    _vm.selectedField == null
                      ? _c("div", { staticStyle: { "padding-left": "15px" } }, [
                          _c("h6", { staticClass: "mt-4" }, [
                            _vm._v("CREATE FORM ELEMENTS"),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              on: { click: _vm.showFormSectionCreator },
                            },
                            [_vm._v("Form Section")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              on: { click: _vm.showAttributeCreator },
                            },
                            [_vm._v("Attribute")]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "mt-4" }, [
                            _vm._v("ADD FORM FIELDS"),
                          ]),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { id: "FormFieldsManagerPlaceholder" } },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.searchPhrase,
                                      expression: "searchPhrase",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "search",
                                    placeholder: "Search...",
                                  },
                                  domProps: { value: _vm.searchPhrase },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.searchPhrase = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(0),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-3" },
                                _vm._l(_vm.attributesSections, function (s) {
                                  return s.filteredAttributes.length
                                    ? _c(
                                        "div",
                                        { key: s.Name, staticClass: "mt-3" },
                                        [
                                          _c(
                                            "h5",
                                            {
                                              staticClass: "font-weight-light",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "text-dark",
                                                  on: {
                                                    click: function ($event) {
                                                      s.Collapsed = !s.Collapsed
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fa",
                                                    class: {
                                                      "fa-angle-down":
                                                        !s.Collapsed,
                                                      "fa-angle-right":
                                                        s.Collapsed,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  s.Name.length > 0
                                                    ? _c("span", [
                                                        _vm._v(_vm._s(s.Name)),
                                                      ])
                                                    : _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-italic",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Uncategorized"
                                                          ),
                                                        ]
                                                      ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          s.Collapsed === false
                                            ? _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row no-gutters",
                                                  },
                                                  _vm._l(
                                                    s.filteredAttributes,
                                                    function (attr) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: attr.Id,
                                                          staticClass:
                                                            "col-6 pb-3 pr-2",
                                                        },
                                                        [
                                                          attr.IsIncluded
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "border rounded px-2 py-3 bg-light",
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0 text-ellipsis font-weight-light text-muted",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "name",
                                                                          attrs:
                                                                            {
                                                                              title:
                                                                                attr.AttributeName,
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                            " +
                                                                              _vm._s(
                                                                                _vm.ellipsis(
                                                                                  attr.AttributeName,
                                                                                  30
                                                                                )
                                                                              ) +
                                                                              "\n                                                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "border rounded px-2 py-3 bg-warning",
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "move",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      attr.AttributeName,
                                                                    draggable:
                                                                      "true",
                                                                  },
                                                                  on: {
                                                                    dragstart:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleDragStart(
                                                                          $event,
                                                                          attr
                                                                        )
                                                                      },
                                                                    dragend:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleDragEnd(
                                                                          $event,
                                                                          attr
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0 text-ellipsis font-weight-light",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "name",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                            " +
                                                                              _vm._s(
                                                                                _vm.ellipsis(
                                                                                  attr.AttributeName,
                                                                                  30
                                                                                )
                                                                              ) +
                                                                              "\n                                                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e()
                                }),
                                0
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedField != null
                      ? _c("div", [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "py-4",
                              staticStyle: { padding: "15px" },
                            },
                            [
                              _c(
                                "form",
                                {
                                  attrs: { id: "field-editor-form" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.handleFieldEditorFormSubmit.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [_vm._v("Attribute:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "form-control",
                                      attrs: { type: "text", readonly: "" },
                                      domProps: {
                                        value: _vm.selectedField.AttributeName,
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [_vm._v("Label:")]),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value: _vm.selectedField.FieldName,
                                          expression: "selectedField.FieldName",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        required: "",
                                        minlength: "2",
                                        maxlength: "100",
                                      },
                                      domProps: {
                                        value: _vm.selectedField.FieldName,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.selectedField,
                                            "FieldName",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [_vm._v("Description:")]),
                                    _vm._v(" "),
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value:
                                            _vm.selectedField.FieldDescription,
                                          expression:
                                            "selectedField.FieldDescription",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { rows: "3" },
                                      domProps: {
                                        value:
                                          _vm.selectedField.FieldDescription,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.selectedField,
                                            "FieldDescription",
                                            $event.target.value.trim()
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.$forceUpdate()
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        "This is text that will be displayed below the form field. Like this one!"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("div", { staticClass: "form-check" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.selectedField.IsFieldRequired,
                                            expression:
                                              "selectedField.IsFieldRequired",
                                          },
                                        ],
                                        staticClass: "form-check-input",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectedField.IsFieldRequired
                                          )
                                            ? _vm._i(
                                                _vm.selectedField
                                                  .IsFieldRequired,
                                                null
                                              ) > -1
                                            : _vm.selectedField.IsFieldRequired,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.selectedField
                                                    .IsFieldRequired,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.selectedField,
                                                      "IsFieldRequired",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.selectedField,
                                                      "IsFieldRequired",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.selectedField,
                                                  "IsFieldRequired",
                                                  $$c
                                                )
                                              }
                                            },
                                            _vm.handleSelectedFieldIsRequiredChange,
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [_vm._v("Required field")]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("div", { staticClass: "form-check" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.selectedField.IsFieldReadonly,
                                            expression:
                                              "selectedField.IsFieldReadonly",
                                          },
                                        ],
                                        staticClass: "form-check-input",
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.selectedField.IsFieldReadonly
                                          )
                                            ? _vm._i(
                                                _vm.selectedField
                                                  .IsFieldReadonly,
                                                null
                                              ) > -1
                                            : _vm.selectedField.IsFieldReadonly,
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$a =
                                                  _vm.selectedField
                                                    .IsFieldReadonly,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.selectedField,
                                                      "IsFieldReadonly",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.selectedField,
                                                      "IsFieldReadonly",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.selectedField,
                                                  "IsFieldReadonly",
                                                  $$c
                                                )
                                              }
                                            },
                                            _vm.handleSelectedFieldIsReadonlyChange,
                                          ],
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        { staticClass: "form-check-label" },
                                        [_vm._v("Readonly field")]
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(2),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-lg-8 col-md-7 col-sm-6 bg-light",
                    staticStyle: {
                      padding: "20px 20px 20px 5px",
                      "max-height": "calc(100vh - 250px)",
                      height: "calc(100vh - 250px)",
                      "overflow-y": "auto",
                    },
                  },
                  [
                    _c("div", { staticStyle: { "padding-left": "30px" } }, [
                      _c("div", { staticClass: "form-group mt-3 px-2 py-1" }, [
                        _c("label", [_vm._v("Blurb:")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.blurb,
                              expression: "blurb",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { rows: "1" },
                          domProps: { value: _vm.blurb },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.blurb = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("small", { staticClass: "form-text text-muted" }, [
                          _vm._v(
                            "Here you can provide a short blurb that will be displayed above the form fields. Up to 100 characters."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.blurbError)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3 px-2 py-1" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v("* "),
                          ]),
                          _vm._v(
                            _vm._s(_vm.alternativeLabel) +
                              " Name\n                                ("
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              on: {
                                click: function ($event) {
                                  _vm.nameReadonly = !_vm.nameReadonly
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.nameReadonly
                                    ? "unset readonly"
                                    : "set readonly"
                                )
                              ),
                            ]
                          ),
                          _vm._v(")\n                            "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "border rounded",
                            class: {
                              "bg-color-gray3": _vm.nameReadonly,
                              "bg-white": !_vm.nameReadonly,
                            },
                          },
                          [
                            _c("p", { staticClass: "text-muted mx-3 my-2" }, [
                              _vm._v("Single line text..."),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3 px-2 py-1" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n                                Description\n                                "
                          ),
                          _vm.includeDescription
                            ? _c("span", [
                                _vm._v(
                                  "\n                                    ("
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    on: {
                                      click: function ($event) {
                                        _vm.descriptionReadonly =
                                          !_vm.descriptionReadonly
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.descriptionReadonly
                                          ? "unset readonly"
                                          : "set readonly"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(")\n                                "),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [
                          _c(
                            "label",
                            {
                              staticClass: "switch float-left",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.includeDescription,
                                    expression: "includeDescription",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.includeDescription)
                                    ? _vm._i(_vm.includeDescription, null) > -1
                                    : _vm.includeDescription,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.includeDescription,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.includeDescription = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.includeDescription = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.includeDescription = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "slider round" }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.includeDescription
                            ? _c(
                                "div",
                                {
                                  staticClass: "border rounded",
                                  class: {
                                    "bg-color-gray3": _vm.descriptionReadonly,
                                    "bg-white": !_vm.descriptionReadonly,
                                  },
                                  staticStyle: { "margin-left": "65px" },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-muted mx-3 my-2" },
                                    [_vm._v("Multi-line text..")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-3 px-2 py-1" }, [
                        _c("p", { staticClass: "mb-1" }, [
                          _vm._v(
                            "\n                                Status\n                                "
                          ),
                          _vm.includeStatus
                            ? _c("span", [
                                _vm._v(
                                  "\n                                    ("
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    on: {
                                      click: function ($event) {
                                        _vm.statusReadonly = !_vm.statusReadonly
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.statusReadonly
                                          ? "unset readonly"
                                          : "set readonly"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(")\n                                "),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }, [
                          _c(
                            "label",
                            {
                              staticClass: "switch float-left",
                              staticStyle: { "margin-top": "4px" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.includeStatus,
                                    expression: "includeStatus",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.includeStatus)
                                    ? _vm._i(_vm.includeStatus, null) > -1
                                    : _vm.includeStatus,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.includeStatus,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.includeStatus = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.includeStatus = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.includeStatus = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "slider round" }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.includeStatus
                            ? _c(
                                "div",
                                {
                                  staticClass: "border rounded",
                                  class: {
                                    "bg-color-gray3": _vm.statusReadonly,
                                    "bg-white": !_vm.statusReadonly,
                                  },
                                  staticStyle: { "margin-left": "65px" },
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "text-muted mx-3 my-2" },
                                    [_vm._v("Drop-down select...")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.formSectionsView, function (s) {
                      return _c(
                        "div",
                        { key: s.Name },
                        [
                          s.Name
                            ? _c(
                                "div",
                                { staticStyle: { "margin-left": "25px" } },
                                [
                                  _c("h5", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "editable editable-warning",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showFormSectionEditor(s)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(s.Name))]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "drop-area",
                            class: {
                              "drop-area-hover": s.IsHovering,
                              "drop-area-show": _vm.draggingAttributeId != null,
                            },
                            on: {
                              dragover: function ($event) {
                                $event.preventDefault()
                              },
                              dragenter: function ($event) {
                                $event.preventDefault()
                                s.IsHovering = true
                              },
                              dragleave: function ($event) {
                                s.IsHovering = false
                              },
                              drop: function ($event) {
                                $event.preventDefault()
                                return _vm.handleDropFormSection($event, s)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.isFormSectionEmptyWarningVisible(s)
                            ? _c(
                                "div",
                                {
                                  staticClass: "alert alert-warning mb-4 mx-4",
                                  attrs: { role: "alert" },
                                },
                                [
                                  _vm._v(
                                    "\n                            Empty sections are not supported. Please add at least 1 field or\n                            "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemoveSection(s)
                                        },
                                      },
                                    },
                                    [_vm._v("remove this section")]
                                  ),
                                  _vm._v(
                                    ".\n                            If you close this window without taking one of these actions, your empty section will be deleted.\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(s.Fields, function (f) {
                            return _c("div", { key: f.Id }, [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex form-field-container",
                                  class: {
                                    selected: _vm.selectedAttributeId === f.Id,
                                    hoverable: _vm.isFormFieldHoverable(f),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "drag-handler bg-warning d-flex align-items-center justify-content-center",
                                      staticStyle: { cursor: "move" },
                                      attrs: {
                                        title: f.FieldName,
                                        draggable: "true",
                                      },
                                      on: {
                                        dragstart: function ($event) {
                                          return _vm.handleDragStart($event, f)
                                        },
                                        dragend: function ($event) {
                                          return _vm.handleDragEnd($event, f)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-ellipsis-v text-white",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "name d-none" },
                                        [_vm._v(_vm._s(f.FieldName))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "w-100 form-field",
                                      attrs: { title: "Edit field" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.selectedAttributeId = f.Id
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "float-right text-dark",
                                          attrs: { title: "Remove field" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleRemoveField(f)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "mb-1" }, [
                                        f.IsFieldRequired
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [_vm._v("*")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "name" }, [
                                          _vm._v(_vm._s(f.FieldName)),
                                        ]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-pencil text-muted",
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "border rounded",
                                          class: {
                                            "bg-color-gray3": f.IsFieldReadonly,
                                            "bg-white": !f.IsFieldReadonly,
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-muted mx-3 my-2",
                                            },
                                            [_vm._v(" ")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted" },
                                        [_vm._v(_vm._s(f.FieldDescription))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "drop-area",
                                class: {
                                  "drop-area-hover": f.IsHovering,
                                  "drop-area-show":
                                    _vm.draggingAttributeId != null,
                                },
                                on: {
                                  dragover: function ($event) {
                                    $event.preventDefault()
                                  },
                                  dragenter: function ($event) {
                                    $event.preventDefault()
                                    f.IsHovering = true
                                  },
                                  dragleave: function ($event) {
                                    f.IsHovering = false
                                  },
                                  drop: function ($event) {
                                    $event.preventDefault()
                                    return _vm.handleDropFormField($event, s, f)
                                  },
                                },
                              }),
                            ])
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "py-3 pl-3 bg-warning" }, [
      _c("h5", { staticClass: "mb-0" }, [_vm._v("Editing the form field")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "text-center mt-5" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-warning",
          attrs: { type: "submit", form: "field-editor-form" },
        },
        [
          _vm._v(
            "\n                                        Done field editing\n                                    "
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }